var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitAttachment($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$tc("documents.documentType", 2)) + "  "),
                _c("span", { staticClass: "required" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-7" },
              [
                _vm.userType === "supplier"
                  ? _c("base-select", {
                      attrs: {
                        options: _vm.invoiceDocumentTypes,
                        searchable: true,
                        "show-labels": false,
                        label: "name",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.$v.attachmentData.documentType.$touch()
                        },
                      },
                      model: {
                        value: _vm.attachmentData.documentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.attachmentData, "documentType", $$v)
                        },
                        expression: "attachmentData.documentType",
                      },
                    })
                  : _vm.userType === "funder"
                  ? _c("base-select", {
                      attrs: {
                        options: _vm.processDocumentTypes,
                        searchable: true,
                        "show-labels": false,
                        label: "name",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.$v.attachmentData.documentType.$touch()
                        },
                      },
                      model: {
                        value: _vm.attachmentData.documentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.attachmentData, "documentType", $$v)
                        },
                        expression: "attachmentData.documentType",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$v.attachmentData.documentType.$error
                  ? _c("div", [
                      !_vm.$v.attachmentData.documentType.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-4 col-form-label input-label" },
              [
                _vm._v(_vm._s(_vm.$t("documents.document")) + " "),
                _c("span", { staticClass: "required" }, [_vm._v(" *")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-7" }, [
              _c("input", {
                ref: "file",
                attrs: { type: "file", accept: "application/pdf" },
                on: {
                  change: _vm.onFileChange,
                  input: function ($event) {
                    return _vm.$v.attachmentData.file.$touch()
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "form-group__message text-danger" }, [
                _vm._v(_vm._s(_vm.$t("documents.documentSizelessthan5MB"))),
              ]),
              _vm._v(" "),
              _vm.$v.attachmentData.file.$error
                ? _c("div", [
                    !_vm.$v.attachmentData.file.required
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [_vm._v(_vm._s(_vm.$tc("validation.required")))]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeAttachmentModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.save")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }